export enum IMErrorType {
  /**
   * 当前连接不可用， 没有建立连接
   */
  NOT_CONNECT = 400,
  MEETING_NOT_FOUNT = 501,
  MEETING_USER_LIMIT,
  MEETING_CAN_NOT_JOIN,
  MEETING_IS_END,
  MEETING_IS_CANCEL,
  TIME_ERROR,
  USER_CAN_NOT_EMPTY,
  START_TIME_MUST_AFTER_NOW,
  START_TIME_MUST_AFTER_END,
  IP_NOT_SET,
  RESOURCE_LIMIT,
  MEETING_REPEAT
}

const message: any = {
  400: "当前连接不可用",
  501: "会议不存在或者已删除",
  502: "已经超过系统允许的总人员数量",
  503: "会议未开始无法加入",
  504: "会议已经结束无法加入",
  505: "会议已经取消无法加入",
  506: "请输入10位时间戳",
  507: "参会人员不能为空",
  508: "预定开始时间必须大于当前时间",
  509: "预定开始时间必须小于预定结束时间",
  510: "IP未配置无法预定",
  511: "会议资源不够，无法预定",
  512: "会议号重复，请重试"
};

class IMError extends Error {
  code: IMErrorType = 500;
  constructor(code: IMErrorType) {
    super(`${code}|${message[code]}`);
    this.code = code;
  }
}
export default IMError;
